import { createSvg } from '../createSvg';

const ArrowLeft = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return <g id={'contour'}>
        <path
            d='M9.57 5.93L3.5 12L9.57 18.07'
            strokeWidth={strokeWidth}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M20.4999 12H3.66992'
            strokeWidth={strokeWidth}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </g>;
};

export default createSvg(
    ArrowLeft,
    'arrow-left',
);
